/* eslint-disable max-lines */
/* eslint-disable sort-keys */
import {fadeInUp} from 'stitches/animations'
import {keyframes} from 'stitches/config'
import {styledLabel} from 'components/Form/styles/FormView'

export const overflow = keyframes({
    '0%': {overflow: 'hidden'},
    '99%': {overflow: 'hidden'},
    'to': {overflow: 'auto'},
})

export const APPEAR_TEXT_DURATION = 1
export const STEP_TEXT_DELAY = 1

export const APPEAR_COMPONENT_DURATION = 0.3
export const STEP_COMPONENT_DELAY = 0.3

// text animations
export const appearTextBase = keyframes({
    '0%': {visibility: 'visible'},
    '100%': {visibility: 'visible'},
})

export const appearTextWidth = keyframes({
    '0%': {width: '50px'},
    '50%': {width: '50px'},
    '80%': {width: '100%'},
    '100%': {width: '100%'},
})

export const appearTextContent = keyframes({
    '0%': {
        visibility: 'hidden',
        width: 0,
        height: 0,
    },
    '79%': {
        visibility: 'hidden',
        width: 0,
        height: 0,
        opacity: 0,
    },
    '80%': {
        visibility: 'visible',
        width: 'auto',
        height: 'auto',
        opacity: 0,
    },
    '100%': {
        visibility: 'visible',
        width: 'auto',
        height: 'auto',
        opacity: 1,
    },
})

export const appearTextLoader = keyframes({
    '0%': {
        visibility: 'visible',
        width: 'auto',
        height: 'auto',
    },
    '79%': {
        visibility: 'visible',
        width: 'auto',
        height: 'auto',
    },
    '80%': {
        visibility: 'hidden',
        width: 0,
        height: 0,
    },
    '100%': {
        visibility: 'hidden',
        width: 0,
        height: 0,
    },
})

export const appearTextDots = keyframes({
    '0%': {content: '.'},
    '33%': {content: '.'},
    '66%': {content: '..'},
    '100%': {content: '...'},
})

// component animations
export const appearComponent = keyframes({
    '0%': {
        visibility: 'visible',
        opacity: 0,
    },
    '100%': {
        visibility: 'visible',
        opacity: 1,
    },
})

export const questionnaireWrapper = {
    'background': '$questionnaireBackground',
    'backgroundSize': '$questionnaire',
    '&&&': {
        animation: `${overflow} 0.5s`,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
}

export const questionnaireInnerWrapper = {
    animation: `${fadeInUp} 0.5s`,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    height: '100%',
    alignItems: 'center',
    width: '100%',
}

export const viewWrapper = {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    flexGrow: 1,
    width: '100%',
}

export const navigationWrapper = {
    width: '100%',
    variants: {
        fixed: {true: {}},
        position: {
            top: {},
            bottom: {},
        },
    },
    compoundVariants: [{
        fixed: true,
        position: 'bottom',
        css: {
            left: 0,
            position: 'sticky',
            right: 0,
            bottom: 0,
        },
    }, {
        fixed: true,
        position: 'top',
        css: {
            left: 0,
            position: 'sticky',
            right: 0,
            top: 0,
        },
    }],
}

export const viewContent = {
    boxSizing: 'border-box',
    flex: 1,
    padding: '20px',
    width: '100%',
    maxWidth: '$questionnaire',
}

export const viewElementWrapper = {
    boxSizing: 'border-box',
    margin: '5px 0',
    variants: {
        hide: {true: {'&&&': {display: 'none'}}},
        isText: {true: {}},
        isComponent: {true: {}},
        lightBot: {true: {}},
        currentElement: {true: {}},
    },
    compoundVariants: [
        {
            isComponent: true,
            lightBot: true,
            currentElement: true,
            css: {
                visibility: 'hidden',
                animation: `${appearComponent} ${APPEAR_COMPONENT_DURATION}s $$delay`,
                animationFillMode: 'forwards',
            },
        },
        {
            isText: true,
            lightBot: true,
            currentElement: true,
            css: {
                visibility: 'hidden',
                animation: `${appearTextBase} 0s $$delay, ${appearTextWidth} ${APPEAR_TEXT_DURATION}s $$delay`,
                animationFillMode: 'forwards',
            },
        },
        {
            isText: true,
            lightBot: true,
            css: {
                background: '$questionnaireLightBotBubbleBackground',
                color: '$questionnaireLightBotBubbleText',
                borderColor: '$questionnaireLightBotBubbleBorder',
                borderWidth: '$questionnaireLightBotBubble',
                borderStyle: '$questionnaireLightBotBubble',
                fontSize: '$questionnaireLightBotBubble',
                fontWeight: '$questionnaireLightBotBubble',
                fontFamily: '$questionnaireLightBotBubble',
                lineHeight: '$questionnaireLightBotBubble',
                fontVariant: '$questionnaireLightBotBubble',
                fontStyle: '$questionnaireLightBotBubble',
                padding: '10px',
                borderRadius: '$questionnaireLightBotBubble',
                borderTopLeftRadius: '3px',
                marginBottom: '10px',
            },
        },
    ],
}

export const textBase = {
    p: {
        'marginBottom': '1em',
        '&:last-child': {marginBottom: 0},
    },
    img: {maxWidth: '100%'},
    a: {
        '&&&': {
            '&:hover': {color: '$questionnaireLinkHover'},
            'color': '$questionnaireLink',
            'fontSize': '$questionnaireLink',
            'fontWeight': '$questionnaireLink',
            'fontStyle': '$questionnaireLink',
            'fontVariant': '$questionnaireLink',
        },
    },
    variants: {lightBot: {true: {'p:last-child': {marginBottom: 0}}}},

}

export const textWrapper = {
    color: '$$color',
    background: '$$background',
    borderRadius: '$$borderRadius',
    boxSizing: 'border-box',
    padding: '$$padding',
    fontSize: '$$fontSize',
    variants: {
        currentElement: {true: {}},
        lightBot: {true: {}},
        align: {
            center: {textAlign: 'center'},
            right: {textAlign: 'right'},
        },
    },
    compoundVariants: [{
        currentElement: true,
        lightBot: true,
        css: {
            visibility: 'hidden',
            width: 0,
            height: 0,
            animation: `${appearTextContent} ${APPEAR_TEXT_DURATION}s`,
            animationDelay: '$$delay',
            animationFillMode: 'forwards',
        },
    }],
}

export const textLoader = {
    '&:after': {
        content: '',
        animation: `${appearTextDots} infinite 1s`,
    },
    'padding': '0 10px',
    'animation': `${appearTextLoader} ${APPEAR_TEXT_DURATION}s`,
    'animationDelay': '$$delay',
    'animationFillMode': 'forwards',
}

export const errorWrapper = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    color: '$questionnaireErrorText',
    fontSize: '14px',
    fontWeight: '600',
    variants: {
        variant: {
            group: {
                background: '$questionnaireErrorBackground',
                color: '$questionnaireErrorGroupText',
                padding: '10px',
                borderRadius: '10px',
                fontSize: '15px',
                fontWeight: '400',
            },
        },
    },
}

export const errorText = {
    color: '$questionnaireErrorText',
    p: {
        'marginBottom': '1em',
        '&:last-child:first-child': {marginBottom: 0},
    },
    variants: {variant: {group: {color: '$questionnaireErrorGroupText'}}},
}

export const errorPage = {
    h1: {color: '$questionnaireErrorTitle'},
    padding: '20px',
    textAlign: 'center',
}

export const questionnaireLabel = {
    ...styledLabel,
    color: '$questionnaireLabel',
    fontSize: '$questionnaireLabel',
    fontWeight: '$questionnaireLabel',
    fontStyle: '$questionnaireLabel',
    fontVariant: '$questionnaireLabel',
    alignItems: 'center',
    display: 'flex',
    flexWrap: 'wrap',
    columnGap: '10px',
    rowGap: '5px',
}

export const questionnaireLabelDescription = {
    color: '$questionnaireLabelDescription',
    fontSize: '$questionnaireLabelDescription',
    fontWeight: '$questionnaireLabelDescription',
    fontStyle: '$questionnaireLabelDescription',
    fontVariant: '$questionnaireLabelDescription',
}

export const questionnaireError = {
    '&& > *': {color: '$questionnaireErrorText'},
    'color': '$questionnaireErrorText',
    'fontSize': '14px',
    'fontWeight': '600',
    'p': {marginBottom: '1em'},
}

export const lightBotAnswerBubble = {
    'display': 'flex',
    'justifyContent': 'flex-end',
    '> div': {
        backgroundColor: '$questionnaireLightBotAnswerBubbleBackground',
        color: '$questionnaireLightBotAnswerBubbleText',
        borderColor: '$questionnaireLightBotAnswerBubbleBorder',
        borderWidth: '$questionnaireLightBotAnswerBubble',
        borderStyle: '$questionnaireLightBotAnswerBubble',
        fontSize: '$questionnaireLightBotAnswerBubble',
        fontWeight: '$questionnaireLightBotAnswerBubble',
        fontFamily: '$questionnaireLightBotAnswerBubble',
        lineHeight: '$questionnaireLightBotAnswerBubble',
        fontVariant: '$questionnaireLightBotAnswerBubble',
        fontStyle: '$questionnaireLightBotAnswerBubble',
        padding: '10px',
        marginTop: '10px',
        borderRadius: '$questionnaireLightBotAnswerBubble',
        borderTopRightRadius: '3px',
    },
}

export const lightBotGroupLabel = {
    color: '$questionnaireLightBotAnswerBubbleLabel',
    fontWeight: '600',
}
